import { toast } from 'react-toastify';

type ToastOptions = Parameters<typeof toast.success>[1];

const showSuccessMessage = (message: string, options?: ToastOptions): void => {
    toast.success(message, options);
};

const showInfoMessage = (message: string, options?: ToastOptions): void => {
    toast.info(message, options);
};

const showErrorMessage = (message: string, options?: ToastOptions): void => {
    toast.error(message, options);
};

export default { showSuccessMessage, showInfoMessage, showErrorMessage };
